import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/components/common/EventTicker.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/components/common/LazyVisible.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/components/common/newCommonComponent/GlobalHeaderNew.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/components/newPageComponent/cma-new/main/new/AboutCMA.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/components/newPageComponent/cma-new/main/new/AI_integreated.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/components/newPageComponent/cma-new/main/new/BannerNew.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/components/newPageComponent/cma-new/main/new/CMA_gameplan.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/components/newPageComponent/cma-new/main/new/CmaEquivalentNew.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/components/newPageComponent/cma-new/main/new/FeesSection.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/components/newPageComponent/cma-new/main/new/JobsAtMncs.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/components/newPageComponent/cma-new/main/new/MilesoneNew.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/components/newPageComponent/cma-new/main/new/NewFaqSection.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/components/newPageComponent/cma-new/main/new/NewGlobalFooter.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/components/newPageComponent/cma-new/main/new/WebinarBannerNew.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/components/newPageComponent/CommonSection/NewInactivityPopup.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/components/newPageComponent/CommonSection/NewStickyFooter.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/components/newPageComponent/cpa-new/main/new/AI_accounting.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/components/newPageComponent/cpa-new/main/new/NewPresence.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/components/newPageComponent/cpa-new/visit/CairaNew.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/components/newPageComponent/new-home/AiLabs.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/shared/lib/lazy-dynamic/dynamic-bailout-to-csr.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/shared/lib/lazy-dynamic/preload-css.js");
